import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { LuX } from "react-icons/lu";
export default function ModalSheet({ open, onClose, title, children, footer }) {
  const dialogRef = useRef(null);
  const closeRef = useRef(onClose);
  closeRef.current = onClose;
  useEffect(() => {
    if (!open) return;
    const dialog = dialogRef.current;
    const focus = document.activeElement;
    const main = document.querySelector(".zy-main");
    const previous = main?.style.overflow;
    if (main) main.style.overflow = "hidden";
    dialog.showModal();
    return () => {
      if (main) main.style.overflow = previous;
      if (dialog.open) dialog.close();
      if (focus?.isConnected) focus.focus();
    };
  }, [open]);
  if (!open) return null;
  return createPortal(
    <dialog
      ref={dialogRef}
      aria-label={title}
      onCancel={() => closeRef.current()}
      onClick={(e) => {
        if (e.target === e.currentTarget) closeRef.current();
      }}
      className="fixed inset-0 m-0 h-[100dvh] max-h-none w-screen max-w-none overflow-hidden border-0 bg-transparent p-0 text-slate-900 backdrop:bg-black/50 open:flex open:items-end dark:text-slate-50 md:p-6 md:open:items-center md:open:justify-center"
    >
      <section className="flex max-h-[85dvh] min-h-0 w-full flex-col overflow-hidden rounded-t-[28px] bg-white shadow-xl dark:bg-[#23272c] md:max-w-[620px] md:rounded-3xl">
        <header className="flex shrink-0 items-center justify-between gap-4 border-b border-slate-200 px-5 py-4 dark:border-slate-700">
          <h2 className="text-xl font-extrabold">{title}</h2>
          <button
            autoFocus
            onClick={() => closeRef.current()}
            aria-label={`Close ${title}`}
            className="grid h-10 w-10 shrink-0 place-items-center rounded-full hover:bg-slate-100 dark:hover:bg-slate-800"
          >
            <LuX size={24} />
          </button>
        </header>
        <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain p-5 pb-[max(20px,env(safe-area-inset-bottom))]">
          {children}
        </div>
        {footer && (
          <footer className="shrink-0 border-t border-slate-200 p-4 pb-[max(16px,env(safe-area-inset-bottom))] text-center text-sm text-slate-500 dark:border-slate-700 dark:text-slate-400">
            {footer}
          </footer>
        )}
      </section>
    </dialog>,
    document.body,
  );
}
